import { cx } from "../../lib/cx.js";
/* empty css         */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Card/Card.tsx
/**
* A surface for one topic: a bordered, rounded container with optional CardHeader,
* CardBody and CardFooter. Panel is the common case, a titled card.
*/
function Card({ elevation = "flat", interactive = false, href, onClick, flush = false, className, children, ...rest }) {
	const classes = cx("ds-card", `ds-card--${elevation}`, interactive && "ds-card--interactive", flush && "ds-card--flush", className);
	if (interactive && href !== void 0) return /* @__PURE__ */ jsx("a", {
		...rest,
		href,
		onClick,
		className: classes,
		children
	});
	if (interactive) {
		const onKeyDown = (event) => {
			rest.onKeyDown?.(event);
			if (event.defaultPrevented || event.target !== event.currentTarget) return;
			if (event.key === "Enter" || event.key === " ") {
				event.preventDefault();
				onClick?.(event);
			}
		};
		return /* @__PURE__ */ jsx("div", {
			role: "button",
			tabIndex: 0,
			...rest,
			onClick,
			onKeyDown,
			className: classes,
			children
		});
	}
	return /* @__PURE__ */ jsx("div", {
		...rest,
		className: classes,
		children
	});
}
/** The card's heading, with an optional subtitle and actions. */
function CardHeader({ title, subtitle, actions, headingLevel = 2, compact = false, className, ...rest }) {
	const Heading = `h${headingLevel}`;
	return /* @__PURE__ */ jsxs("div", {
		...rest,
		className: cx("ds-card__header", compact && "ds-card__header--compact", className),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "ds-card__titles",
			children: [/* @__PURE__ */ jsx(Heading, {
				className: "ds-card__title",
				children: title
			}), subtitle && /* @__PURE__ */ jsx("p", {
				className: "ds-card__subtitle",
				children: subtitle
			})]
		}), actions && /* @__PURE__ */ jsx("div", {
			className: "ds-card__actions",
			children: actions
		})]
	});
}
/** The card's content. A flush card's body has no padding. */
function CardBody({ className, ...rest }) {
	return /* @__PURE__ */ jsx("div", {
		...rest,
		className: cx("ds-card__body", className)
	});
}
/** Under the body, above a divider: the card's actions or a summary line. */
function CardFooter({ className, ...rest }) {
	return /* @__PURE__ */ jsx("div", {
		...rest,
		className: cx("ds-card__footer", className)
	});
}
/**
* A titled card, the prototype's panel: a compact header band (title and meta, with
* actions) over the body. "White-label configuration", the check-detail header.
*/
function Panel({ title, meta, actions, headingLevel, children, ...rest }) {
	return /* @__PURE__ */ jsxs(Card, {
		...rest,
		children: [/* @__PURE__ */ jsx(CardHeader, {
			compact: true,
			title,
			subtitle: meta,
			actions,
			...headingLevel !== void 0 && { headingLevel }
		}), /* @__PURE__ */ jsx(CardBody, { children })]
	});
}
//#endregion
export { Card, CardBody, CardFooter, CardHeader, Panel };

//# sourceMappingURL=Card.js.map